import { AbgSxProps } from '@abg/typings';

export const containerStyling: AbgSxProps = {
  padding: { xs: '8px 16px 16px', sm: '8px 24px 24px' },
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gridRow: 2,
  overflow: 'hidden',
};

export const footerContainerStyling: AbgSxProps = {
  display: 'flex',
  justifyContent: 'space-between',
};

export const oldPriceStyling: AbgSxProps = {
  marginBottom: '4px',
};

export const bookAgainStyling: AbgSxProps = {
  height: 'fit-content',
  alignSelf: 'flex-end',
  padding: '8px 16px',
  marginLeft: '15px',
};

export const recommendedStyling: AbgSxProps = {
  height: 'fit-content',
  alignSelf: 'flex-end',
  padding: '4px 8px',
  marginLeft: '15px',
};
